var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._t("default"),(_vm.$slots.content)?_c('div',{staticClass:"card__content",class:_vm.contentClass},[_vm._t("content")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }